/* eslint-disable jsx-a11y/alt-text */
import { Link } from "react-router-dom";
import Footer from "../../common/Footer";
import Hero from "../../common/Hero";
import Navbar from "../../common/Navbar";
import image from "../../assests/images/Ruislip.png";

function Ruislip() {
  return (
    <>
      <Navbar />
      <Hero text="Ruislip" text1="Professional Services" image={image} />

      {/* SECTION 1 – INTRO */}
      <section className="py-16 bg-gray-50">
        <div className="text-center max-w-4xl mx-auto">
          <p className="text-[#ED5521] text-4xl font-semibold">Ruislip Services</p>
          <h1 className="text-3xl md:text-5xl font-bold text-neutral-800 mt-4">
            Expert Blinds, Carpet & Furniture Installers
          </h1>
          <p className="text-[16px] md:text-[20px] mt-6 text-neutral-600 leading-relaxed">
            Our Ruislip team delivers fast, professional, and reliable installation services for blinds, carpets, furniture, and sofas. Each project is executed with precision, care, and a clean finish.
          </p>
          <p className="text-[16px] md:text-[20px] mt-4 text-neutral-600 leading-relaxed">
            We cater to homes, offices, and commercial spaces across Ruislip, ensuring smooth and tailored installations for every property.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-6">
          {["./images/Card6.jpg", "./images/Card4.jpg", "./images/Card1.jpg"].map((img, idx) => (
            <div
              key={idx}
              className="w-40 h-40 md:w-52 md:h-52 rounded-xl shadow-lg overflow-hidden flex items-center justify-center"
            >
              <img src={img} alt={`Team Member ${idx + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </section>

      {/* SECTION 2 – ABOUT */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-6 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-800">
            Serving Homes & Businesses Across Ruislip
          </h2>
          <p className="text-[16px] md:text-[20px] mt-4 text-neutral-600 leading-relaxed">
            From Ruislip Lido to nearby neighborhoods, our professional installation team ensures clean, reliable, and efficient services for homes, offices, shops, and rental properties.
          </p>
          <p className="text-[16px] md:text-[20px] mt-4 text-neutral-600 leading-relaxed">
            No matter the size of your project, we guarantee professional results and complete customer satisfaction.
          </p>
        </div>
      </section>

      {/* SECTION 3 – SERVICES CHECKLIST */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-2xl lg:text-4xl font-bold text-[#ED5521] text-center lg:text-left">
            Our Installation Packages
          </h2>
          <p className="mt-4 text-neutral-500 text-center lg:text-left">
            Comprehensive home & office installation services designed for fast, precise, and reliable results.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: "Blinds Installation", desc: "Roller, Venetian, Vertical & Wooden blinds" },
              { title: "Carpet Installation", desc: "Bedroom, hallway, stairs & full home carpets" },
              { title: "Furniture Assembly", desc: "Wardrobes, beds, tables, desks & cabinets" },
              { title: "Sofa Setup", desc: "Sectional, recliner & L-shape sofa setup" },
              { title: "Fixing & Adjustments", desc: "Re-fitting blinds, levelling furniture, carpet fixing" },
            ].map((service, idx) => (
              <div key={idx} className="p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition">
                <h3 className="text-xl font-semibold text-neutral-800">{service.title}</h3>
                <p className="mt-2 text-neutral-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 4 – HIGHLIGHT BOX */}
      <section className="py-16 bg-[#FEF6F0]">
        <div className="max-w-4xl mx-auto px-6 text-center rounded-xl border-l-4 border-[#ED5521] p-6 shadow-md">
          <h2 className="text-3xl md:text-4xl font-bold text-[#ED5521]">Why Choose Us?</h2>
          <p className="mt-4 text-neutral-700 text-[16px] md:text-[20px] leading-relaxed">
            Trusted by hundreds of customers in Ruislip, our team provides skilled installers, same-day service options, transparent pricing, and guaranteed clean, precise work.
          </p>
          <ul className="mt-4 text-neutral-700 text-left list-disc list-inside space-y-2">
            <li>✓ Verified, professional installation experts</li>
            <li>✓ Affordable pricing with no hidden charges</li>
            <li>✓ Fast, same-day & next-day service</li>
            <li>✓ Safe, clean & reliable installations</li>
            <li>✓ Accurate fitting with professional tools</li>
          </ul>
        </div>
      </section>

      {/* SECTION 5 – SERVICE AREAS */}
      <section className="py-16 bg-white">
        <div className="text-center">
          <h2 className="text-4xl font-semibold text-neutral-800">Ruislip Installation Service Areas</h2>
          <p className="mt-4 text-neutral-500 text-[16px] md:text-[20px] leading-relaxed max-w-3xl mx-auto">
            Providing professional blinds, carpet, furniture, and sofa installation across Ruislip and surrounding neighborhoods.
          </p>

          <Link to="/book">
            <button className="mt-6 bg-transparent text-[#ED5521] font-bold py-2 px-6 rounded border border-[#ED5521] hover:bg-[#ED5521] hover:text-white transition">
              Book Installation
            </button>
          </Link>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {[
              "Ruislip Lido",
              "Breakspear Road",
              "Ruislip Manor",
              "Eastcote Lane",
              "Ickenham Road",
              "Swakeleys Road",
              "Ruislip High Street",
              "West End Lane",
            ].map((area, idx) => (
              <div key={idx} className="bg-[#FEF6F0] p-4 rounded-lg shadow hover:shadow-md transition">
                <p className="font-semibold text-gray-700">{area}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 6 – CTA */}
      <section className="py-16 bg-[#ED5521] text-white text-center">
        <h2 className="text-3xl md:text-4xl font-bold">Ready to Book Your Installation?</h2>
        <p className="mt-4 text-[16px] md:text-[20px] leading-relaxed max-w-3xl mx-auto">
          Get professional blinds, carpet, furniture, and sofa installation with guaranteed satisfaction. Fast, reliable, and affordable service in Ruislip.
        </p>
        <Link to="/book">
          <button className="mt-6 bg-white text-[#ED5521] font-bold py-3 px-6 rounded-lg shadow hover:bg-gray-100 transition">
            Book Now
          </button>
        </Link>
      </section>

      <Footer />
    </>
  );
}

export default Ruislip;
